
import React from "react";
import { Card, CardContent } from "@/components/ui/card";

type WelcomeSectionProps = {
  user: any;
  stats: {
    total: number;
    favorites: number;
    recentUpdates: number;
    lastEditedDate: string;
  };
};

export const WelcomeSection = ({ user, stats }: WelcomeSectionProps) => {
  return (
    <Card className="bg-gradient-to-r from-primary/10 to-secondary/10">
      <CardContent className="pt-6">
        <div className="flex flex-col md:flex-row md:items-center justify-between">
          <div className="mb-4 md:mb-0">
            <h2 className="text-2xl font-bold mb-1">
              {new Date().getHours() < 12
                ? "Good morning"
                : new Date().getHours() < 18
                ? "Good afternoon"
                : "Good evening"}
              , {user?.email?.split('@')[0]}!
            </h2>
            <p className="text-muted-foreground">
              {new Date().toLocaleDateString(undefined, { 
                weekday: 'long', 
                month: 'long', 
                day: 'numeric' 
              })}
            </p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
            <div className="p-3 bg-background rounded-lg">
              <div className="text-2xl font-bold">{stats.total}</div>
              <div className="text-xs text-muted-foreground">Total Entries</div>
            </div>
            <div className="p-3 bg-background rounded-lg">
              <div className="text-2xl font-bold">{stats.favorites}</div>
              <div className="text-xs text-muted-foreground">Favorites</div>
            </div>
            <div className="p-3 bg-background rounded-lg">
              <div className="text-2xl font-bold">{stats.recentUpdates}</div>
              <div className="text-xs text-muted-foreground">Recent Updates</div>
            </div>
            <div className="p-3 bg-background rounded-lg">
              <div className="text-sm font-bold">{stats.lastEditedDate}</div>
              <div className="text-xs text-muted-foreground">Last Edit</div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
